import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { LuPhone } from 'react-icons/lu';
import { CiMail } from 'react-icons/ci';
import { GrLocation } from 'react-icons/gr';
import { FaLinkedinIn, FaTwitter, FaFacebookF } from 'react-icons/fa';
import { RiInstagramFill } from 'react-icons/ri';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <footer className="footer-container">
      <section className="footer-section footer-contact">
        <h3>Contact Us</h3>
        <div className="footer-container-row">
          <LuPhone />
          <a href="tel:+919310156985">+91 93101 56985</a>
        </div>
        <div className="footer-container-row">
          <CiMail />
          <a href="mailto:contact@evencargo.in">contact@evencargo.in</a>
        </div>
        <div className="footer-container-row">
          <GrLocation />
          <p>630, Lane No. 4, Westend Marg, Saket, New Delhi - 110030</p>
        </div>
      </section>

      <section className="footer-section footer-container-quick">
        <h3>Quick Links</h3>
        <Link to="/" className="footer-container-link" onClick={scrollToTop}>Home</Link>
        <Link to="/about" className="footer-container-link" onClick={scrollToTop}>About</Link>
        <Link to="/service" className="footer-container-link" onClick={scrollToTop}>Services</Link>
        <Link to="/blog" className="footer-container-link" onClick={scrollToTop}>Blog</Link>
        <Link to="/contact" className="footer-container-link" onClick={scrollToTop}>Contact</Link>
      </section>

      <section className="footer-section">
        <h3>Follow Us</h3>
        <div className="footer-container-follow">
          <a href="https://www.linkedin.com/company/even-cargo/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedinIn />
          </a>
          <a href="https://www.instagram.com/even_cargo/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <RiInstagramFill />
          </a>
          <a href="https://twitter.com/EvenCargo" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <FaTwitter />
          </a>
          <a href="https://www.facebook.com/evencargo/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebookF />
          </a>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
